<template>
	<div>
		<notifications position="top center" group="info" />

		<h1>Champs supplémentaires de profil</h1>

		<b-button @click="save">Sauvegarder</b-button>

		<br /><br />

		<b-table
			thead-tr-class="d-flex"
			tbody-tr-class="d-flex"
			striped
			hover
			:items="profile"
			:fields="[
				{ key: 'name', label: 'Nom', class: 'col-sm-3' },
				{ key: 'libelle', label: 'Nom affiché', class: 'col-sm-3' },
				{ key: 'type', label: 'Type', class: 'col-sm-2' },
				{ key: 'edit', label: 'Editable', class: 'col-sm-1' },
				{ key: 'hide', label: 'Cacher', class: 'col-sm-1' },
				{ key: 'id', label: '', class: 'col-sm-2' },
			]">
			<template v-slot:cell(name)="row">
				<b-form-input v-model="row.item.name" />
			</template>
			<template v-slot:cell(libelle)="row">
				<b-form-input v-model="row.item.libelle" />
			</template>
			<template v-slot:cell(type)="row">
				<b-form-select
					:options="[
						{ value: 'text', text: 'Texte' },
						{ value: 'number', text: 'Nombre' },
						{ value: 'checkbox', text: 'Case à cocher' },
						{ value: 'password', text: 'Mot de passe' },
						{ value: 'date', text: 'Date' },
						{ value: 'time', text: 'Heure' },
					]"
					v-model="row.item.type" />
			</template>
			<template v-slot:cell(edit)="row">
				<input type="checkbox" v-model="row.item.edit" />
			</template>
			<template v-slot:cell(hide)="row">
				<input type="checkbox" v-model="row.item.hide" />
			</template>
			<template v-slot:cell(id)="row">
				<b-button @click="delete_row(row.item.id)"
					><i class="fas fa-trash-alt"></i
				></b-button>
			</template>
		</b-table>
		<b-button @click="add">Ajouter</b-button>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";

	import users from "../services/users.js";
	import client from "../services/client.js";

	export default {
		name: "edit_profile",
		data() {
			return {
				client: {},
				profile: [],
			};
		},
		methods: {
			async save() {
				await client.put(null, this.profile);

				this.$notify({
					group: "info",
					title: "Configuration du profil sauvegardé",
					type: "success",
				});
			},
			add() {
				this.profile.push({
					id: this.$uuid.v4(),
					name: "",
					libelle: "",
					type: "text",
					edit: false,
					hide: false
				});
			},
			delete_row(id) {
				for (var i = 0; i < this.profile.length; i++) {
					if (this.profile[i].id == id) {
						this.profile.splice(i, 1);
						break;
					}
				}
			},
		},
		mounted: async function () {
			if (
				store.state.user.rules &&
				!store.state.user.rules.fields_profile
			) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			if (!this.client.details) this.cient.details = {};

			if (!this.client.details.profile) {
				this.profile = [];
			} else {
				this.profile = this.client.details.profile;
			}
		},
	};
</script>
